import { FC } from 'react';

import { Form, Input } from 'antd';
import { motion } from 'framer-motion';

import { useTranslation } from 'react-i18next';
import { standardAnimationProps } from '../../../../constants/animations';
import styles from './InterviewLinkForm.module.scss';

interface InterviewLinkFormProps {
  form: any;
  isVisible: boolean;
  onValidateUrl: (url: string) => boolean;
  disabled: boolean;
}

const InterviewLinkForm: FC<InterviewLinkFormProps> = ({
  form,
  isVisible,
  onValidateUrl,
  disabled
}) => {
  const { t } = useTranslation()

  if (!isVisible) return null;

  return (
    <motion.div {...standardAnimationProps}>
      <Form form={form} layout="vertical" className={styles.formContainer}>
        <Form.Item
          name="meetingLink"
          label={t('interviewLink.title')}
          rules={[
            {
              required: true,
              message: t('interviewLink.inputMeetingLink')
            },
            {
              validator: (_, value) => {
                if (!value || value.trim().length === 0) {
                  return Promise.resolve();
                }
                if (onValidateUrl(value.trim())) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error(
                    t('interviewLink.inputNotValid')
                  )
                );
              }
            }
          ]}
        >
          <Input placeholder="https://zoom.us/..." disabled={disabled} />
        </Form.Item>
      </Form>
    </motion.div>
  );
};

export default InterviewLinkForm;
